import * as React from 'react';
import {
    Dialog,
    DialogTitle,
    IconButton,
    PaperProps,
} from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

interface ResizableDialogProps {
    open: boolean;
    canExpand:boolean;
    banner?: JSX.Element;
    onClose: (_event: object, reason: "backdropClick" | "escapeKeyDown") => Promise<void>|void;
    actions?:JSX.Element;
    children?: React.ReactNode;
    title: string|JSX.Element;
    initialSettings:PaperProps;
}

const ResizableDialog: React.FC<ResizableDialogProps> = ({
    open,
    onClose,
    children,
    initialSettings,
    title,
    actions,
    canExpand,
    banner
    
}) => {
    const [expanded, setExpanded] = React.useState(false);
    const toggleSize = () => setExpanded((prev) => !prev);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={expanded}
            PaperProps={
                expanded ? {sx: { m: 0, width: '100%', height: '100%' } }
                    : initialSettings
            }
        >
            { !!banner && banner }
            <DialogTitle sx={{ pr: 6 }}>
                {title}
                { actions }
                {
                    canExpand &&
                    <IconButton
                        aria-label={expanded ? 'Restore size' : 'Maximize'}
                        onClick={toggleSize}
                        sx={{ position: 'absolute', top: 8, right: 8 }}
                        size="small"
                    >
                        {expanded ? <FullscreenExitIcon /> : <FullscreenIcon />}
                    </IconButton>
                }
            </DialogTitle>
            {children}
        </Dialog>
    );
};

export default ResizableDialog;